import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Fab from './Fab.jsx';

const FAB_SIZE_EXT_COEF = 1.06;
const TITLE_FONT_ADJ_COEF = 33;

const WrappedFab = props => (
  <div style={{margin: '1.1em 0'}}>
    <StyledFab
      size={props.size * FAB_SIZE_EXT_COEF}
      theme="yellowBorder"
      {...props}
    />
  </div>
);

const propTypes = {
  size: PropTypes.number,
  onInfoButtonClick: PropTypes.func,
  onDirectionsButtonClick: PropTypes.func,
  onShareButtonClick: PropTypes.func,
  title: PropTypes.string,
  categories: PropTypes.string,
};
const defaultProps = {
  size: 16,
};

const Container = styled.div`
  font-size: ${props => props.size}px;
`;
const InnerContainer = styled.div`
  position: relative;
  width: 32em;
  height: 32em;
  background-color: transparent;
  ///////////////
  margin: 0 auto;
`;
const MajorTriangle = styled.div`
  border-top: 16em solid #f5c75d;
  border-bottom: 16em solid transparent;
  border-left: 16em solid #f5c75d;
  border-right: 16em solid transparent;
  width: 0;
`;
const MinorTriangle = styled.div`
  position: absolute;
  top:0.45em;
  right:0;
  border-top: 11em solid transparent;
  border-bottom: 11em solid #f5c75d;
  border-left: 11em solid transparent;
  border-right: 11em solid #f5c75d;
  width: 0;
`;
const MajorTriangleInfo = styled.div`
  position: absolute;
  top: 0.6em;
  left: 0.9em;
`;
const MinorTriangleInfo = styled.div`
  bottom: 10.4em;
  position: absolute;
  right: 0.9em;
  z-index: 1;
  text-align: right;
`;
const Title = styled.div`
  color: white; 
  font-size: ${props => {
    console.log('Title Length: ', props.length);
    if (props.length >= 10) {
      return TITLE_FONT_ADJ_COEF/props.length
    }
    return 3.8
  }}em;
  margin-left: -0.05em;
  text-transform: uppercase
`;
const Text = styled.div`
  color: ${props => props.accent
  ? 'var(--accent-color)'
  : '#fff'
  };
  font-size: 1.4em;
  margin-bottom: 0.1em;
`;
const Categories = styled(Text)`
  ${props => (
      props.isOverflow ? (`
        overflow-x: scroll;
        width: ${OVERFLOW_CONTAINER_WIDTH};
        overflow-y: hidden;
        height: 69px;
        white-space: pre;
        ::-webkit-scrollbar {
          height: 0;
        }
      `) : 'max-width: 16em;'
    )
}`;

const StyledFab = styled(Fab)`
  display: inline-block;
	padding-right: 2em;
	// background: black;
`;
const TextFab = styled(WrappedFab)`
  margin-bottom: 0.5em;
`;
const Mark = styled.span`
  display: inline-block;
  color: white;
  border: 0.15em solid white;
  border-radius: 100%;
  padding: 0.1em 0.4em;
  font-size: 1.4em;
  margin-bottom: 0.5em;
`;

const STR_MAX_LENGHT = 34;
const OVERFLOW_CONTAINER_WIDTH = '17em';

class PoiDetailsView extends React.Component {
  render () {
    const {
      size,
      onInfoButtonClick,
      onDirectionsButtonClick,
      onShareButtonClick,
      title,
      categories,
    } = this.props;
    
    const isOverflow = categories !== null ? categories.length > STR_MAX_LENGHT : false;
    return <Container size={size}>
      <InnerContainer size={size}>
        <MajorTriangleInfo>
          <Title length={title && title.length}>{title}</Title>
          <Categories isOverflow={isOverflow}>{categories}</Categories>
          <TextFab
            isTextLowerCased
            text='directions'
            size={size}
            onClick={onDirectionsButtonClick}
          />
          {/*<WrappedFab*/}
            {/*iconName='info'*/}
            {/*onClick={onInfoButtonClick}*/}
            {/*size={size}*/}
          {/*/>*/}
          {/*<WrappedFab*/}
            {/*iconName='save_alt'*/}
            {/*size={size}*/}
            {/*onClick={onShareButtonClick}*/}
          {/*/>*/}
        </MajorTriangleInfo>
        <MajorTriangle size={size} />
        <MinorTriangleInfo size={size}>
          <Mark>P</Mark>
          <Text>Open - Close</Text>
          <Text accent={true}>(123) 456 - 7890</Text>
        </MinorTriangleInfo>
        <MinorTriangle size={size} />
      </InnerContainer>
    </Container>
  }
}

PoiDetailsView.defaultProps = defaultProps;
PoiDetailsView.propTypes = propTypes;

export default PoiDetailsView;



// WEBPACK FOOTER //
// ./src/components/PoiDetailsView/TriangledView.jsx